module.exports = __webpack_public_path__ + "static/media/audit.554fcccc.png";